import { Box, withStyles } from '@material-ui/core';
import {
  SelectedOptions,
  SelectedOptionsProps
} from './components/selected-options';

const SelectedOptionsContainer = withStyles(() => ({
  root: {
    position: 'fixed',
    bottom: 20,
    left: '50%',
    transform: 'translateX(-50%)'
  }
}))(Box);

export const ActionBar = <T,>(props: SelectedOptionsProps<T>) => (
  <SelectedOptionsContainer>
    <SelectedOptions {...props} />
  </SelectedOptionsContainer>
);
